import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Programs from './Programs';

class ProgramsContainer extends Component {
  static propTypes = {
    programNames: PropTypes.array,
  };

  render() {
    return (
      <div className="ppvx_row">
        <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
          <Programs programNames={this.props.programNames} />
        </div>
      </div>
    );
  }
}
export default ProgramsContainer;
